export default __webpack_public_path__ + "static/media/dole-juice-wood-bg.28ba15b1.png";